import Modal from "components/DesignSystem/Modal/Modal";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useToast } from "hooks/useToast";
import React from "react";
import { EntityCreationForm } from "signInSignUp/EntityCreationForm";

import { useCreateCompanyAndEntityMutation } from "store/apis/salesCrm";

type UserDataPayLoad = {
  first_name: string;
  last_name: string;
  email: string;
  mobile: string;
  linkedin: string;
};

type AddCrmEntityTableModalProps = {
  showModal: boolean;
  setModalShow: (newState: React.SetStateAction<boolean>) => void;
  setShowGroupModal: (newState: React.SetStateAction<boolean>) => void;
  userDataPayload: UserDataPayLoad[] | null;
  groupName: string;
  websiteName?: string;
};

const AddCrmEntityTableModal = ({
  showModal,
  setModalShow,
  setShowGroupModal,
  userDataPayload,
  groupName,
  websiteName,
}: AddCrmEntityTableModalProps) => {
  const { alertToast, successToast } = useToast();
  const [createCompanyAndEntity, { isLoading: isCreating }] =
    useCreateCompanyAndEntityMutation();
  const { isForeignCA } = useRoleBasedView();

  const handleClose = () => {
    setModalShow(false);
  };

  const moveBack = () => {
    setModalShow(false);
    setShowGroupModal(true);
  };

  const onFormSubmitHandler = async (
    entities: {
      state_id: string | null;
      formation_type_id: string;
      company_name: string;
    }[],
    files: Record<string, File>
  ) => {
    try {
      if (entities.length === 0) return;

      const groupEntityPayload = {
        group_name: groupName,
        website_name: websiteName,
        user_data: userDataPayload,
        entity_data: entities,
        ...files,
      };

      await createCompanyAndEntity(groupEntityPayload).unwrap();
      successToast({ title: "Group created" });
      setModalShow(false);
      setShowGroupModal(false);
    } catch (error: any) {
      alertToast({ message: error?.data?.error?.message });
      throw error;
    }
  };

  return (
    <Modal.Root open={showModal} onOpenChange={handleClose}>
      <Modal.Content size="xl">
        <Modal.Header>
          <Modal.Title>
            Add {isForeignCA ? "legal entity information" : "Entity"}
          </Modal.Title>
          <Modal.Close className="t-mt-2" />
        </Modal.Header>
        <Modal.Body>
          <EntityCreationForm
            groupName={groupName}
            isFromAdmin
            moveBack={moveBack}
            onAdminSubmit={onFormSubmitHandler}
            isCreating={isCreating}
          />
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};

export default AddCrmEntityTableModal;
